import { pricingUtils } from "@flights/web-api-utils-universal";
export const getFlexibleTicketTotalPriceFromFlight = (flight) => {
    const flexibleTicket = flight.ancillaries?.flexibleTicket;
    if (!flexibleTicket)
        throw Error("Missing flexible ticket data");
    return getFlexibleTicketTotalPrice(flight, flexibleTicket);
};
export const getFlexibleTicketTotalPrice = (flight, flexibleTicket, extras) => {
    return pricingUtils.sumPriceBreakdown([
        flight.priceBreakdown,
        getFlexibleTicketTotalUpgradePrice(flexibleTicket),
        ...(extras ?? [])
    ]);
};
export const getFlexibleTicketTotalUpgradePrice = (flexibleTicket) => pricingUtils.sumPriceBreakdown(flexibleTicket.travellers.map(() => flexibleTicket.priceBreakdown));
export const getCfarTicketTotalPriceFromFlight = (flight) => {
    const cfar = flight.ancillaries?.cancelForAnyReason;
    if (!cfar)
        return;
    return pricingUtils.sumPriceBreakdown([flight.priceBreakdown, cfar.priceBreakdown]);
};
